<template>
  <div>
    <label for="municipio">{{ titulo }}</label>
    <b-skeleton-wrapper :loading="municipioLoader">
      <template #loading>
        <b-skeleton
          type="button"
          width="100%"
          class="mb-75"
        />
      </template>
      <v-select
        id="municipio"
        placeholder="Búsque el municipio y seleccionelo"
        label="nombre"
        :filterable="false"
        :options="municipios"
        :clearable="clear"
        :value="muni"
        @input="(val) => $emit('selectmuni', val)"
        @search="onSearch"
      >
        <!-- CUANDO NO HAY OPCIONES -->
        <template #no-options>
          Teclea al menos 4 letras del municipio y seleccionelo
        </template>
        <!-- COMO SE VEN LAS OPCIONES -->
        <template #option="{ nombre }">
          <span>{{ nombre }}</span>
        </template>
        <!-- COMO SE VE LA OPCIÓN SELECCIONADA -->
        <template
          #selected-option="{ nombre }"
        >
          <div>
            <b class="text-primary">{{ nombre }}</b>
          </div>
        </template>
      </v-select>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import {
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref, watch } from '@vue/composition-api'
import { getData } from '@core/utils/http/general'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    vSelect,
    BSkeletonWrapper,
    BSkeleton,
  },
  props: {
    titulo: {
      type: [String, null],
      default: 'Municipio',
    },
    ef: {
      type: [Object, null],
      default: null,
    },
    muni: {
      type: [Object, null],
      default: null,
    },
    clear: {
      type: [Boolean, null],
      default: false,
    },
  },
  setup(props) {
    const municipios = ref([])
    const toast = useToast()
    const municipioLoader = ref(false)
    let datos = {}
    const onSearch = (search, loading) => {
      if (search.length <= 3) return false
      loading(true)
      // const ef = props.ef.id ? props.ef.id : null
      const ef = (props.ef && props.ef.id) ? props.ef.id : null
      if (ef === null) datos = { action: 25, search }
      else datos = { action: 25, search, ef }
      getData(datos)
        .then(response => {
          loading(false)
          if (response.status !== 200) {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Información de solicitud',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            },
            { timeout: 8000 })
            municipios.value = []
            return false
          }
          municipios.value = response.data.data
          return true
        })
        .catch(err => {
          loading(false)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error buscando municipios',
              text: err,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
        })
      return true
    }
    watch(() => props.muni, value => {
      if (value === null) {
        municipios.value = []
      }
    })
    return {
      municipios,
      municipioLoader,
      onSearch,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
